module.exports = __webpack_public_path__ + "img/cambodia.393f7ffe.png";